import { Stack, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { AIStyledText } from 'components/AI/AIStyles';

export const AIFileNameTitle = () => (
  <Stack
    direction="row"
    gap={0.625}
    alignItems="center"
    className="form-group form-inline-label"
    sx={{ marginBottom: '0' }}
  >
    <Typography component="label">Manage file name</Typography>
    <Stack
      direction="row"
      alignItems="center"
      gap={0.625}
      sx={{ color: '#00afcc' }}
    >
      <AutoAwesome sx={{ width: '14px', height: '14px' }} />
      <AIStyledText>AI</AIStyledText>
    </Stack>
  </Stack>
);
